import './TargetingHeader.scss';

import React, { memo } from 'react';

import bem, { withOptionalClassName } from '../../utils/bem';
import TargetingViewButton from '../AdForm/TargetingViewButton';
import { formatCountryIdsAsNames, useCountryNames } from '../hooks/useCountryNames';
import type { TargetingHeaderProps } from './types';

const [block, element] = bem('targeting-header');

const TargetingHeader = ({
  textView,
  onSetTextView,
  editMode,
  countryLabel,
  publisherLabel,
  lineItemCountryIds,
  lineItemPublishers,
  flags,
  classNames = {},
}: TargetingHeaderProps): React.JSX.Element => {
  const { countryMap } = useCountryNames();

  return (
    <div className={block()}>
      <div>
        <p className={withOptionalClassName(element('country'), classNames?.country)}>
          {countryLabel}
          {formatCountryIdsAsNames(lineItemCountryIds, countryMap)}
        </p>
        <p className={withOptionalClassName(element('publisher'), classNames?.publisher)}>
          {publisherLabel}
          {lineItemPublishers}
        </p>
      </div>
      {flags.targetingTextViewRelease && onSetTextView && (
        <div className={withOptionalClassName(element('view'), classNames?.viewAction)}>
          <TargetingViewButton isActive={textView ?? false} setActive={onSetTextView} editMode={editMode} />
        </div>
      )}
    </div>
  );
};

export default memo(TargetingHeader);
